// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import globalMixin from '@/mixins'
import store from '@/store'
import Vuelidate from 'vuelidate'
import { formatDate, formatDateTime, formatMoney, fromNow } from '@/utils/dateFormat'

// Vue Bootstrap
import BootstrapVue from 'bootstrap-vue'

// Bootstrap Css Files
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../node_modules/nprogress/nprogress.css'

// Importing Global Css
require("@/assets/vendor/nucleo/css/nucleo.css");
// require("@/assets/vendor/fortawesome/fontawesome-free/css/all.min.css");
require("@/assets/css/myCloud.css");
require("@/assets/css/styles.css");
require("@/assets/css/responsive.css");

require("@/assets/vendor/jquery/dist/jquery.min.js");
// require("@/assets/vendor/bootstrap/dist/js/bootstrap.bundle.min.js");
// require("@/assets/vendor/chart.js/dist/Chart.min.js");
// require("@/assets/vendor/chart.js/dist/Chart.extension.js");
require("@/assets/js/myCloud.js");

Vue.use(BootstrapVue);
Vue.mixin(globalMixin);
Vue.use(VueResource);
Vue.use(Vuelidate)

Vue.config.productionTip = false
Vue.config.silent = true

var numeral = require("numeral");


//Filters

Vue.filter('fmtDate',     value => formatDate(value))
Vue.filter('fmtDateTime', value => formatDateTime(value))
Vue.filter('fromNow',     value => fromNow(value))
Vue.filter('currency',    value => formatMoney(value))

Vue.filter("formatNumber", function (value) {
  // return numeral(value).format("0,0"); // displaying other groupings/separators is possible, look at the docs
  return numeral(value).format("0,0.000"); // 0,0.000 for 3 decimal places
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js